import {
  Instagram,
  Music2,
  Video,
  Globe,
  Camera,
  Ticket,
  Boxes,
  Handshake,
  Youtube,
  DollarSign,
} from "lucide-react";

const COLORS = [
  { name: "Red", hex: "#FF1E1E" },
  { name: "Pink", hex: "#FF1493" },
  { name: "Gold", hex: "#FFC107" },
  { name: "White", hex: "#FFFFFF" },
  { name: "Black", hex: "#000000" },
];

const PERFECT_FOR = [
  { icon: <Handshake />, label: "Brand Partnerships" },
  { icon: <Boxes />, label: "Product Collabs" },
  { icon: <Ticket />, label: "Event Sponsorships" },
  { icon: <Camera />, label: "Social Media Features" },
  { icon: <Video />, label: "Content Integrations" },
];

const SOCIALS = [
  { icon: <Instagram />, label: "@fuelmeh", href: "https://instagram.com/fuelmeh" },
  { icon: <Music2 />, label: "@fmaa.fuelmeh · TikTok", href: "https://tiktok.com/@fmaa.fuelmeh" },
  { icon: <Youtube />, label: "@FMAA-FUELMEH · YouTube", href: "https://www.youtube.com/@FMAA-FUELMEH" },
  { icon: <Globe />, label: "www.fuelmeh.com", href: "https://www.fuelmeh.com" },
  { icon: <DollarSign />, label: "$FuelMeh · Venmo", href: "https://venmo.com/u/FuelMeh" },
  { icon: <DollarSign />, label: "$FMAAFuelMeh · Cash App", href: "https://cash.app/$FMAAFuelMeh" },
];

export default function BrandKit() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-8 py-16 grid md:grid-cols-12 gap-10">
      <div className="md:col-span-6">
        <div className="overline">Brand colors</div>
        <h2 className="font-display text-3xl md:text-4xl uppercase mt-3">The palette</h2>
        <div className="grid grid-cols-5 gap-3 mt-7">
          {COLORS.map((c) => (
            <div key={c.hex} className="text-center" data-testid={`color-${c.name.toLowerCase()}`}>
              <div
                className="aspect-square border border-white/10"
                style={{ background: c.hex }}
              />
              <div className="mt-2 font-display text-sm tracking-[0.18em]">{c.name}</div>
              <div className="font-mono-tactical text-[10px] text-white/50 uppercase">{c.hex}</div>
            </div>
          ))}
        </div>
        <div className="mt-10">
          <div className="overline">Typography</div>
          <div className="mt-4 space-y-3">
            <div>
              <div className="font-display text-3xl tracking-[0.05em]">FMAA</div>
              <div className="text-xs font-mono-tactical text-white/50 uppercase tracking-[0.2em]">
                Headers · Impact (graffiti / display)
              </div>
            </div>
            <div>
              <div className="font-script text-3xl">Your Favorite Roadside Distraction</div>
              <div className="text-xs font-mono-tactical text-white/50 uppercase tracking-[0.2em]">
                Accent · Script
              </div>
            </div>
            <div>
              <div className="text-base tracking-[0.25em] uppercase">FuelMeh Across America</div>
              <div className="text-xs font-mono-tactical text-white/50 uppercase tracking-[0.2em]">
                Body · Clean
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="md:col-span-6">
        <div className="overline">Perfect for</div>
        <h2 className="font-display text-3xl md:text-4xl uppercase mt-3">Where brands plug in</h2>
        <div className="grid grid-cols-2 gap-3 mt-7">
          {PERFECT_FOR.map((p) => (
            <div
              key={p.label}
              className="tac-card p-5 flex items-center gap-3"
              data-testid={`perfect-for-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="text-[#FFC107]">{p.icon}</span>
              <span className="font-display tracking-[0.12em] text-sm uppercase">{p.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <div className="overline">Connect &amp; fuel the journey</div>
          <ul className="mt-4 space-y-3 text-base">
            {SOCIALS.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 text-white/85 hover:text-white"
                >
                  <span className="text-[#FF1493]">{s.icon}</span>
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
